import React from 'react'

import TextSection from './sections/Text'
import IntroductionSection from './sections/Introduction'
import SponsorSection from './sections/Sponsors'
import FAQSection from './sections/FAQ'

const InfoSection = (props) => {
  const { node } = props.data
  const containerType = node.frontmatter.container
  if (containerType === 'text') {
    return (
      <TextSection node={ node } />
    )
  } else if (containerType === 'intro') {
    return (
      <IntroductionSection node={ node } />
    )
  } else if (containerType === 'faq') {
    return (
      <FAQSection node={ node } />
    )
  } else if (containerType === 'sponsor') {
    return (
      <SponsorSection node={ node } />
    )
  }
  return (<span />)
}

export default InfoSection
